import styled from 'styled-components'
import { RAG } from 'features/dashboard/charts/scoreColour'
import { SecondaryButton } from './ui'

export const LOAD_ERROR_TEXT = 'We couldn’t load these remedials. Please try again.'

const LoadError = ({ text = LOAD_ERROR_TEXT, onRetry, compact = false }) => (
  <Box role='alert' $compact={compact}>
    <Message>{text}</Message>
    {onRetry && <SecondaryButton type='button' onClick={onRetry}>Try again</SecondaryButton>}
  </Box>
)

export default LoadError

const Box = styled.div`
  display: flex;
  flex-direction: ${({ $compact }) => ($compact ? 'column' : 'row')};
  flex-wrap: wrap;
  align-items: ${({ $compact }) => ($compact ? 'stretch' : 'center')};
  justify-content: space-between;
  gap: 8px 12px;
  padding: 12px;
  border: 1px solid ${RAG.critical.bg};
  border-left: 4px solid ${RAG.critical.fg};
  border-radius: 8px;
  background: #fff;
`

const Message = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.45;
  color: ${RAG.critical.fg};
  font-weight: 600;
`
